import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ShipmentsApiService } from '@features/shipments/services/shipments-api.service';
import { Shipment } from '@shared-features/models/shipment';
import { WCCDeliveryNoteLine } from '@features/shipment-creation-template/models/wcc-delivery-note-line';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { specialProductTypes } from '@shared/constants/special-products.constant';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cement-info',
  templateUrl: './cement-info.component.html',
  styleUrls: ['./cement-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CementInfoComponent extends BaseComponent implements OnChanges {
  @Input() shipment: Shipment = new Shipment();
  deliveryNoteLines: WCCDeliveryNoteLine[];
  isSpecialProductType: boolean = false;
  specialProductTypesArray: string[] = specialProductTypes;

  constructor(
    private shipmentsApiService: ShipmentsApiService,
    private changeRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnChanges({ shipment }: SimpleChanges): void {
    if (shipment && shipment.currentValue !== shipment.previousValue) {
      this.load(
        this.shipmentsApiService.getWCCDeliveryNoteLine(
          this.shipment.id,
          this.shipment.customer?.id
        ),
        {
          emptyContentCheck: (v) => !v,
        }
      )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.deliveryNoteLines = res;

          // these product types are special because they does not have amount
          // so present the order amount as loaded amount
          if (this.specialProductTypesArray.includes(this.deliveryNoteLines?.[0]?.productId))
            this.isSpecialProductType = true;
          this.changeRef.markForCheck();
        });
    }
  }
}
